import { ContentLayout } from "@/modules/core/views/templates";
import { profiles } from "@/modules/core/enums/profiles.enum";

export default [
  {
    path: "/painel",
    component: ContentLayout,
    sidebar: {
      name: "Painel",
      icon: "mdi-view-dashboard",
      index: 1,
      permissions: [
        profiles.PRESIDENT.id,
        profiles.DIRECTOR.id,
        profiles.PUBLIC_RELATIONS_DIRECTOR.id,
        profiles.MANAGER_OPERATING.id
      ]
    },
    children: [
      {
        name: "panel",
        path: "",
        meta: {
          title: "Painel",
          public: false,
          permissions: [
            profiles.PRESIDENT.id,
            profiles.DIRECTOR.id,
            profiles.PUBLIC_RELATIONS_DIRECTOR.id,
            profiles.MANAGER_OPERATING.id
          ]
        },
        component: () => import("@/modules/panel/views/pages/Panel.vue")
      }
    ]
  }
];
